"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SAVE_OFFER_TO_BASKET_MODAL_KEY = exports.GET_ACTIVE_BASKET_UI = exports.DELETE_ACTIVE_BASKET_UI = exports.COUNT_BASKETS_SIMPLIFIED_WITHOUT_OFFER = exports.BOOTSTRAP_UI = void 0;
var BOOTSTRAP_UI = exports.BOOTSTRAP_UI = 'SAVE_OFFER_TO_BASKET_MODAL';
var GET_ACTIVE_BASKET_UI = exports.GET_ACTIVE_BASKET_UI = 'GET_ACTIVE_BASKET_UI ';
var DELETE_ACTIVE_BASKET_UI = exports.DELETE_ACTIVE_BASKET_UI = 'DELETE_ACTIVE_BASKET_UI ';
var COUNT_BASKETS_SIMPLIFIED_WITHOUT_OFFER = exports.COUNT_BASKETS_SIMPLIFIED_WITHOUT_OFFER = 4;
var SAVE_OFFER_TO_BASKET_MODAL_KEY = exports.SAVE_OFFER_TO_BASKET_MODAL_KEY = 'SAVE_OFFER_TO_BASKET_MODAL';